import { formatDeliveryDate } from '@utils/formatDate';
import { formatPriceLong } from '@utils/numberFormatter';

export const BUYCARCARD_CONFIG = {
  expressDelivery: {
    text: (minWaitingPeriod: number) => `Express delivery by ${formatDeliveryDate(minWaitingPeriod)}`
  },
  upcoming: {
    text: (minWaitingPeriod: number) => `Expected launch on ${formatDeliveryDate(minWaitingPeriod)}`
  },
  rating: {
    text: (score: string) => `${Number(score)}/10 Expert rating`
  },
  variants: {
    text: (count: number) => `${count} Variant${count > 1 ? 's' : ''}`
  },
  price: {
    loggedIn: {
      label: "ACKO Drive price starts from",
      format: (price: number) => `${formatPriceLong(price)}`,
      originalPrice: (price: number) => `${formatPriceLong(price)}`,
      savings: (amount: number) => `Save ₹${amount.toLocaleString('en-IN', { maximumFractionDigits: 0 })}`
    },
    loggedOut: {
      label: `On-road price`,
      formatRange: (minPrice: number, maxPrice: number) => 
        `${formatPriceLong(minPrice)} – ${formatPriceLong(maxPrice)}`,
      savings: (amount: number) => `Savings up to ₹${amount.toLocaleString('en-IN', { maximumFractionDigits: 0 })} on ACKO Drive`
    }
  },
  buttons: {
    loggedIn: {
      text: "View details"
    },
    loggedOut: {
      text: "Unlock exclusive price"
    },
    wishlist: {
      ariaLabel: {
        add: 'Add to wishlist',
        remove: 'Remove from wishlist'
      },
      icons: {
        active: '/icons/wishlist-favourite.svg',
        inactive: '/icons/wishlist.svg'
      }
    }
  }
};